"use client";

import { useEffect, useRef } from "react";

export function IframeDemo() {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const centerIframe = () => {
      if (scrollRef.current) {
        const { scrollWidth, clientWidth } = scrollRef.current;
        if (scrollWidth > clientWidth) {
          scrollRef.current.scrollLeft = (scrollWidth - clientWidth) / 2;
        }
      }
    };

    // Center on initial mount
    centerIframe();

    // Re-center continuously when resizing down
    window.addEventListener("resize", centerIframe);
    return () => window.removeEventListener("resize", centerIframe);
  }, []);

  return (
    <section id="use-cases" className="w-full bg-[#050511] relative border-t border-white/10 pt-16 md:pt-24 pb-0">
      <div className="w-full max-w-[896px] mx-auto px-4 flex flex-col items-center mb-10 md:mb-16">
        <h2 className="text-center text-4xl md:text-[48px] font-[350] leading-tight mb-6 text-white">
          Explore use cases
        </h2>
        <p className="text-center text-[15.5px] text-[#76767c] font-[400] leading-relaxed max-w-[800px]">
          See how the Internet of Cognition empowers specialized agents to work together seamlessly to solve complex enterprise challenges.
        </p>
      </div>
      {/* 
        Product Team constraints:
        - 16:10 ratio
        - Minimum interactive: 960x600
        - Absolute minimum floor: 800x500
        
        We use an overflow-x-auto wrapper so mobile users can pan horizontally
        if their screen is less than 400px wide, preserving legibility.
      */}
      <div 
        ref={scrollRef}
        className="w-full overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
      >
        <div className="w-full min-w-[400px] mx-auto md:min-w-[975px] aspect-[16/10] max-w-[1920px]">
          <iframe
            src="https://cis-os-ci-v18.intelligaia.com/"
            className="w-full h-full border-0"
            title="Internet of Cognition Demo"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
}
